
<template>
    <div class="pb-4">
        <div class="fixed-top setup-navbar">
            <img src="../../assets/images/setup/logo.svg" alt="Rush Logo">
        </div>
        <h1 class="text-center">Verify Account</h1>
        <p class="text-center description">Lorem ipsum dolor sit amet, co nsectetur adipiscing elit. Lorem ipsum dolor sit amet, consect etur.</p>
        <b-row>
            <b-col></b-col>
            <b-col>
                <div class="setup-form-wrapper container px-5 py-4">
                    <b-row>
                        <b-col>
                            <b-form>
                                <b-form-group
                                    id="government-id-fieldset"
                                    label="Upload Government ID"
                                    label-for="government-id"
                                >
                                    <b-form-file
                                        id="government-id"
                                        placeholder="Select File..."
                                    ></b-form-file>
                                </b-form-group>
                                <b-form-group
                                    id="masking-fieldset"
                                    label="Masking Name"
                                    label-for="masking"
                                >
                                    <b-form-input id="masking" placeholder="Enter Masking Name"></b-form-input>
                                </b-form-group>
                                <b-form-group
                                    id="tin-number-fieldset"
                                    label="TIN Number"
                                    label-for="tin-number"
                                >
                                    <b-form-input id="tin-number" placeholder="Enter TIN Number"></b-form-input>
                                </b-form-group>
                                <div id="checkbox-wrapper">
                                <b-form-checkbox
                                    id="checkbox-1"
                                    name="checkbox-1"
                                    value="accepted"
                                    class="mx-auto d-block mt-4 mb-4"
                                    style="width: 205px;"
                                    unchecked-value="not_accepted"
                                >
                                    I agree to the <a href="">Terms &amp; Conditions</a>    
                                </b-form-checkbox>
                                </div>
                                <b-button type="submit" variant="primary" class="mx-auto py-3 d-block">Submit</b-button>
                            </b-form>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col></b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'setup',
    data() {
        return {

        }
    },
    methods: {
    }
};
</script>
<style lang="scss">
.col-form-label {
    font-size: 13px;
    color: #33363A;
}
#checkbox-wrapper {
    .custom-control-label {
        font-size: 12px;
    }
}
.btn-primary {
    width: 183px;
    font-size: 18px;
}
</style>